import { format } from 'date-fns';
import { es, enUS, pt } from 'date-fns/locale';

const CHILE_TZ = 'America/Santiago';

/**
 * Converts a date string to a Date object in Chile timezone.
 */
export const toChileDate = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  // Create a date string in Chile timezone, then parse it back
  const chileStr = date.toLocaleString('sv-SE', { timeZone: CHILE_TZ });
  return new Date(chileStr);
};

/**
 * Format a date string to Chile timezone with date-fns.
 * @param {string} dateStr - ISO date string
 * @param {string} fmt - date-fns format string
 * @param {string} locale - 'es', 'en', or 'pt'
 */
export const formatChile = (dateStr, fmt = "d MMM", locale = 'es') => {
  if (!dateStr) return '';
  const date = toChileDate(dateStr);
  const localeMap = { es, en: enUS, pt };
  return format(date, fmt, { locale: localeMap[locale] || es });
};

/**
 * Format date + time for admin/display using native Intl API.
 * Returns something like "25/02/2026, 14:30"
 */
export const formatDateTimeChile = (dateStr) => {
  if (!dateStr) return 'Sin fecha';
  try {
    const date = new Date(dateStr);
    return date.toLocaleString('es-CL', {
      timeZone: CHILE_TZ,
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return 'Fecha inválida';
  }
};
